import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-download\"><defs><style type=\"text/css\"></style></defs><path d=\"M554.666667 940.202667l413.013333-409.6H620.373333V0h-187.733333v530.602667H85.333333l413.013334 409.6c9.386667 18.602667 46.933333 18.602667 56.32 0z\" p-id=\"13461\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/download.svg
// module id = 1026
// module chunks = 38